export const RENDER_GENERATION_POLLING_INTERVAL = 5000;
